export default __webpack_public_path__ + "static/media/youji.e3ffdbd2.svg";